document.addEventListener('DOMContentLoaded', function () {
  const gridContainer = document.querySelector('#product-grid');
  const loadMoreBtn = document.querySelector('#load-more-button');

  if (!gridContainer || !loadMoreBtn) return;

  loadMoreBtn.addEventListener('click', function () {
    const nextUrl = this.dataset.nextUrl;
    if (!nextUrl) return;

    loadMoreBtn.textContent = 'Loading...';

    fetch(nextUrl)
      .then(response => response.text())
      .then((html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        const newItems = doc.querySelectorAll('#product-grid > li');
        const newButton = doc.querySelector('#load-more-button');

        newItems.forEach(item => {
          gridContainer.appendChild(item);
        });

        if (newButton) {
          loadMoreBtn.dataset.nextUrl = newButton.dataset.nextUrl;
          loadMoreBtn.textContent = 'Load More';
        } else {
          loadMoreBtn.remove();
        }
      })
      .catch(err => {
        console.error('Load more failed:', err);
        loadMoreBtn.textContent = 'Error';
      });
  });
});
